export interface Vault {
  readonly id: string
  readonly name: string
  readonly apy: number
  readonly rateBasis: string
  readonly summary: string
  readonly risk: number
  readonly term: string
  readonly liquidity: string
  readonly minimum: number
  readonly holds: string
  readonly icon: string
}

export const VAULTS: readonly Vault[] = [
  {
    id: 'vault',
    name: 'Vault',
    apy: 0.0205,
    rateBasis: 'SOFR − 1.80',
    summary:
      'Your balance keeps earning while it sits. Withdraw on any day, and the rate moves with the market rather than against you.',
    risk: 0.1,
    term: 'No term',
    liquidity: 'Same day',
    minimum: 1,
    holds: 'Cash at partner banks',
    icon: 'savings',
  },
  {
    id: 'ladder',
    name: 'Treasury ladder',
    apy: 0.0415,
    rateBasis: '1–12 month bills',
    summary:
      'A ladder of US Treasury bills bought at a fixed yield. Locked for the term you pick, which is what buys you the higher rate.',
    risk: 0.25,
    term: '1 to 12 months',
    liquidity: 'At maturity',
    minimum: 500,
    holds: 'US Treasury bills',
    icon: 'account_balance',
  },
  {
    id: 'assets',
    name: 'Real assets',
    apy: 0.092,
    rateBasis: 'Rent, net of fees',
    summary:
      'Fractional shares of buildings in the corridors you already send money to. Rent every month, and the value can fall.',
    risk: 0.7,
    term: 'Until completion',
    liquidity: 'Secondary market only',
    minimum: 100,
    holds: 'Property, through a local vehicle',
    icon: 'apartment',
  },
]
